export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9714.7769f9d9.jpg";